export function setPendingTaskId(id) {
  return (dispatch) => {
    dispatch({type: 'SET_PENDING_TASK_ID', payload: id});
  };
}

export function resetPendingTaskId() {
  return (dispatch) => {
    dispatch({type: 'RESET_PENDING_TASK_ID', payload: ''});
  };
}

export function setTotalNominalSortasi(data) {
  return (dispatch) => {
    dispatch({type: 'SET_TOTAL_NOMINAL_SORTASI', payload: data});
  };
}

export function resetTotalNominalSortasi() {
  return (dispatch) => {
    dispatch({type: 'RESET_TOTAL_NOMINAL_SORTASI', payload: 0});
  };
}

export function setAttachmentSealList(data) {
  return (dispatch) => {
    dispatch({type: 'SET_ATTACHMENT_SEAL_LIST', payload: data});
  };
}

export function setAttachmentSealListNew(data) {
  return (dispatch) => {
    dispatch({type: 'SET_ATTACHMENT_SEAL_LIST_NEW', payload: data});
  };
}

export function resetAttachmentSealList() {
  return (dispatch) => {
    dispatch({type: 'SET_ATTACHMENT_SEAL_LIST', payload: []});
  };
}

export function resetAttachmentSealListNew() {
  return (dispatch) => {
    dispatch({type: 'SET_ATTACHMENT_SEAL_LIST_NEW', payload: []});
  };
}

export function setAttachmentUangList(data) {
  return (dispatch) => {
    dispatch({type: 'SET_ATTACHMENT_UANG_LIST', payload: data});
  };
}

export function setAttachmentUangListNew(data) {
  return (dispatch) => {
    dispatch({type: 'SET_ATTACHMENT_UANG_LIST_NEW', payload: data});
  };
}

export function setMoneyAttachment(data) {
  return (dispatch) => {
    dispatch({type: 'SET_MONEY_ATTACHMENT', payload: data});
  };
}

export function resetAttachmentUangList() {
  return (dispatch) => {
    dispatch({type: 'SET_ATTACHMENT_UANG_LIST', payload: []});
  };
}

export function resetAttachmentUangListNew() {
  return (dispatch) => {
    dispatch({type: 'SET_ATTACHMENT_UANG_LIST_NEW', payload: []});
  };
}
export function addDataHasilSortasi(data) {
  return (dispatch) => {
    dispatch({type: 'ADD_DATA_HASIL_SORTASI', payload: data});
  };
}

export function resetAddDataHasilSortasi() {
  return (dispatch) => {
    dispatch({type: 'RESET_ADD_DATA_HASIL_SORTASI', payload: [{}]});
  };
}

export function addDataKonfirmasiSelisih(data) {
  return (dispatch) => {
    dispatch({type: 'ADD_DATA_KONFIRMASI_SELISIH', payload: data});
  };
}

export function resetAddDataKonfirmasiSelisih() {
  return (dispatch) => {
    dispatch({type: 'RESET_ADD_DATA_KONFIRMASI_SELISIH', payload: [{}]});
  };
}

export function setTotalKonfirmasiSelisih(data) {
  return (dispatch) => {
    dispatch({type: 'TOTAL_KONFIRMASI_SELISIH', payload: data});
  };
}

export function resetTotalKonfirmasiSelisih() {
  return (dispatch) => {
    dispatch({type: 'RESET_TOTAL_KONFIRMASI_SELISIH', payload: 0});
  };
}

export function setLinkRekamanCctv(data) {
  return (dispatch) => {
    dispatch({type: 'SET_LINK_REKAMAN_CCTV', payload: data});
  };
}

export function resetLinkRekamanCctv() {
  return (dispatch) => {
    dispatch({type: 'RESET_LINK_REKAMAN_CCTV', payload: ''});
  };
}

export function setJumlahSortasi(data) {
  return (dispatch) => {
    dispatch({type: 'SET_JUMLAH_SORTASI', payload: data});
  };
}

export function resetJumlahSortasi() {
  return (dispatch) => {
    dispatch({type: 'RESET_JUMLAH_SORTASI', payload: 0});
  };
}

export function addAttachmentSealList(data) {
  return (dispatch) => {
    dispatch({type: 'ADD_ATTACHMENT_SEAL_LIST', payload: data});
  };
}

export function resetAddAttachmentSealList() {
  return (dispatch) => {
    dispatch({type: 'RESET_ADD_ATTACHMENT_SEAL_LIST', payload: []});
  };
}

export function addAttachmentUangList(data) {
  return (dispatch) => {
    dispatch({type: 'ADD_ATTACHMENT_UANG_LIST', payload: data});
  };
}

export function resetAddAttachmentUangList() {
  return (dispatch) => {
    dispatch({type: 'RESET_ADD_ATTACHMENT_UANG_LIST', payload: []});
  };
}

export function jumlahSelisih(data) {
  return (dispatch) => {
    dispatch({type: 'JUMLAH_SELISIH', payload: data});
  };
}

export function resetjumlahSelisih() {
  return (dispatch) => {
    dispatch({type: 'RESET_JUMLAH_SELISIH', payload: []});
  };
}

export function setSealSuccess(data) {
  return (dispatch) => {
    dispatch({type: 'SET_SEAL_SUCCESS', payload: data});
  };
}

export function setMoneySuccess(data) {
  return (dispatch) => {
    dispatch({type: 'SET_MONEY_SUCCESS', payload: data});
  };
}
